import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { PaperTexture } from "./PaperTexture";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <PaperTexture />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

// Shared centered content column wrapper.
export const Column = ({ children, className = "", testid }) => (
  <div className={`mx-auto max-w-[720px] px-6 md:px-8 ${className}`} data-testid={testid}>
    {children}
  </div>
);
